export enum ExternalWalletType {
    METAMASK = "MetaMask",
    COINBASE = "CoinBase"
}